module.exports = __webpack_public_path__ + "img/guide4_pc.05723cfc.png";